import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { Field, ErrorMessage } from 'formik'
import { camelCase } from 'lodash'
import MaskedInput from 'react-text-mask'
import * as Yup from 'yup'

export const CustomerPayPalCart = ({ cart, eventCode, handleSubmit, ppid, ppurl, returnUrl }) => (
  <form action={ppurl} method='post' name='customer-paypal' id='customer-paypal' className='paypal-form' onSubmit={handleSubmit}>
    <input type='hidden' name='cmd' value='_cart' />
    <input type='hidden' name='upload' value='1' />
    <input type='hidden' name='business' value={ppid} />
    <input type='hidden' name='currency_code' value='USD' />
    <input type='hidden' name='no_note' value='1' />
    <input type='hidden' name='no_shipping' value='1' />
    <input type='hidden' name='invoice' value={cart.id} />

    {cart.items.map((item, index) => (
      <React.Fragment key={index}>
        <input type='hidden' name={`item_number_${index + 1}`} value={item.id} />
        <input type='hidden' name={`item_name_${index + 1}`} value={`${item.data.firstName} ${item.data.lastName} - ${eventCode}`} />
        <input type='hidden' name={`amount_${index + 1}`} value={item.price} />
      </React.Fragment>
    ))}

    <input type='hidden' name='return' value={`${window.location.origin}${returnUrl}`} />
    <input type='hidden' name='cancel_return' value={window.location.href} />
    <button type='submit' className='paypal-submit'>
      <i /> PayPal
    </button>
  </form>
)

export const SponsorPayPalBuyNow = ({ cart, sponsorship, eventCode, handleSubmit, ppid, ppurl, returnUrl }) => (
  <form action={ppurl} method='post' name='sponsor-paypal' id='sponsor-paypal' className='paypal-form' onSubmit={handleSubmit}>
    <input type='hidden' name='cmd' value='_xclick' />
    <input type='hidden' name='business' value={ppid} />
    <input type='hidden' name='currency_code' value='USD' />
    <input type='hidden' name='no_note' value='1' />
    <input type='hidden' name='no_shipping' value='1' />
    <input type='hidden' name='invoice' value={cart.id} />

    <input type='hidden' name={'item_number'} value={sponsorship.id} />
    <input type='hidden' name={'item_name'} value={`FNTG Sponsorship - ${eventCode} - ${sponsorship.name}`} />
    <input type='hidden' name={'amount'} value={cart.totalAmount} />

    <input type='hidden' name='return' value={`${window.location.origin}${returnUrl}`} />
    <input type='hidden' name='cancel_return' value={window.location.href} />
    <button type='submit' className='paypal-submit'>
      <i /> PayPal
    </button>
  </form>
)

export const DfsRequirementsModal = ({ on, toggle }) => (
  <div>
    <Modal isOpen={on} toggle={toggle} className='modal-dialog-centered'>
      <ModalHeader toggle={toggle}>Requirements to qualify for DFS credit</ModalHeader>
      <ModalBody>
        <ul>
          <li>You <strong>must</strong> show a government-issued photo ID at the event check-in</li>
          <li>You <strong>must</strong> sign in AND out of each course in the green folder that
            will be handed out at your table. If you don't sign in and out
            of a course, you will not receive credit for that course.</li>
        </ul>
        <p>
          Once the above requirements are met, FNF Florida Agency will promptly submit your credits post-seminar
          to DFS and issue a Certificate of Completion to you at the address provided in this form.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color='primary' onClick={toggle}>OK</Button>{' '}
      </ModalFooter>
    </Modal>
  </div>
)

export const PayPalNoticeModal = ({ on, toggle }) => (
  <div>
    <Modal isOpen={on} toggle={toggle} className='modal-dialog-centered'>
      <ModalHeader toggle={toggle}>Redirecting to PayPal</ModalHeader>
      <ModalBody>
        Hang on, we are taking you to PayPal's secure servers to complete your transaction. This should only take a few seconds.
      </ModalBody>
      <ModalFooter />
    </Modal>
  </div>
)

export const CheckFormModal = ({ on, toggle, openForm, completeRegistrationLink }) => (
  <div>
    <Button className='check-form-trigger' onClick={toggle}><i /> Check Payment</Button>
    <Modal isOpen={on} toggle={toggle} className='modal-dialog-centered'>
      <ModalHeader toggle={toggle}>Check Payment</ModalHeader>
      <ModalBody className='text-justify'>
        <p>Please take a moment to download and review the Check Payment Form below and include a copy with your check.
          Then click <strong>"Complete Registration"</strong> to submit your information.</p>
        <Button color='warning' onClick={openForm}>Review Form</Button>
      </ModalBody>
      <ModalFooter>
        <a className='btn btn-primary' href={completeRegistrationLink}>Complete Registration</a>
        <Button color='secondary' onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  </div>
)

export const RegistrationCompleteModal = ({ on, toggle, cart, onBadges, onNewRegistration }) => (
  <div>
    <Modal isOpen={on} toggle={toggle} className='modal-dialog-centered'>
      <ModalHeader toggle={toggle}>Registration Complete | Cart {cart.id}</ModalHeader>
      <ModalBody className='text-justify'>
        <p>Total: <strong>${cart.totalAmount.toFixed(2).toLocaleString()}</strong></p>
        <ul>
          {cart.items.map(item => (
            <li className='cart-item' key={item.id}>
              <strong>{item.id} - {item.data.firstName} {item.data.lastName} - ${(item.price.toFixed(2)).toLocaleString()}</strong>
            </li>
          ))}
        </ul>
      </ModalBody>
      <ModalFooter>
        <Button color='primary' onClick={onBadges}>Generate Badges</Button>
        <Button color='primary' onClick={onNewRegistration}>New Registration</Button>
      </ModalFooter>
    </Modal>
  </div>
)

export const AuthorizedCheckout = ({ completeRegistrationLink }) => (
  <a href={completeRegistrationLink} className='authorized-checkout-button'><i /> Confirm Registration</a>
)

const RegistrationOptions = ({ section, form }) => (
  <section>
    <div className='field'>
      <label htmlFor={`options.${camelCase(section.name)}`}>{section.name}</label>
      <Field
        name={`options.${camelCase(section.name)}`}
        type='text'
        id={`options.${camelCase(section.name)}`}
        component='select'
      >
        <option value=''>-- Please Select --</option>
        {section.options && section.options.map(item => (
          <option key={item.id} value={item.code}>{item.name}</option>
        ))}

      </Field>
      <ErrorMessage component='small' name={`options.${camelCase(section.name)}`} className='errors' />
    </div>
  </section>
)

export const EmployeeInfoForm = ({ form, setFocusedInput }) => (
  <section>
    <div className='field'>
      <label htmlFor='firstName'>First Name</label>
      <Field
        type='firstName'
        name='firstName'
        id='firstName'
        innerRef={(input) => { setFocusedInput(input) }}
      />
      <ErrorMessage component='small' name='firstName' className='errors' />
    </div>
    <div className='field'>
      <label htmlFor='lastName'>Last Name</label>
      <Field type='lastName' name='lastName' id='lastName' />
      <ErrorMessage component='small' name='lastName' className='errors' />
    </div>
    <div className='field'>
      <label htmlFor='email'>Email Address</label>
      <Field name='email' type='text' id='email' />
      <ErrorMessage component='small' name='email' className='errors' />
    </div>
  </section>
)

export const CustomerInfoForm = ({ form, accountManagers, setFocusedInput }) => (
  <React.Fragment>
    <section>

      <div className='field'>
        <label htmlFor='firstName'>First Name</label>
        <Field
          type='firstName'
          name='firstName'
          id='firstName'
          innerRef={(input) => { setFocusedInput(input) }}
        />
        <ErrorMessage component='small' name='firstName' className='errors' />
      </div>

      <div className='field'>
        <label htmlFor='lastName'>Last Name</label>
        <Field
          type='lastName'
          name='lastName'
          id='lastName'
        />
        <ErrorMessage component='small' name='lastName' className='errors' />
      </div>

    </section>

    <section>
      <div className='field'>
        <label htmlFor='company'>Company / Firm</label>
        <Field
          name='company'
          type='text'
          id='company'
        />
        <ErrorMessage component='small' name='company' className='errors' />
      </div>
      <div className='field'>
        <label htmlFor='accountManager'>Account Manager</label>
        <Field
          name='accountManager'
          type='text'
          id='accountManager'
          component='select'
        >
          <option value=''>-- Please Select --</option>
          {accountManagers.map((item, index) => (
            <option key={index} value={item}>{item}</option>
          ))}
          <option value='Unknown'>-- I don't know! --</option>

        </Field>
        <ErrorMessage component='small' name='accountManager' className='errors' />
      </div>
    </section>

    <section>
      <div className='field'>
        <label htmlFor='email'>Email Address</label>
        <Field
          name='email'
          type='text'
          className='form-control'
          id='email'
        />
        <ErrorMessage component='small' name='email' className='errors' />
      </div>
      <div className='field'>
        <label htmlFor='phone'>Phone Number</label>
        <Field
          name='phone'
          type='tel'
          className='form-control'
          id='phone'
          component={MaskedInput}
          mask={phoneNumberMask}
          placeholderChar={'\u2000'}
          onChange={form.handleChange}
          onBlur={form.handleBlur}
          value={form.values.phone}
        />
        <ErrorMessage component='small' name='phone' className='errors' />
      </div>
    </section>

  </React.Fragment>
)

const ShareContactInfoForm = ({ form }) => (
  <React.Fragment>

    <section>
      <div className='field'>
        <div className='checkbox'>
          <Field
            type='checkbox'
            name='shareContactInfo'
            id='shareContactInfo'
            checked={form.values.shareContactInfo}
          />
          <label>
            Attendee would like to participate in giveaways and special offers from event sponsors, and agree to share basic contact information with them for this purpose
          </label>
        </div>
      </div>
    </section>
  </React.Fragment>
)

const DfsForm = ({ section, form, toggleDfsRequirementsModal }) => (
  <React.Fragment>

    <section>
      <div className='field'>
        <div className='checkbox'>
          <Field name='requireDfs' type='checkbox' id='requireDfs' checked={form.values.requireDfs} />
          <label htmlFor='requireDfs'>Attendee requires credits from the Department of Financial Services (DFS) and acknowledges the
          </label> <a href='#' onClick={toggleDfsRequirementsModal}>DFS requirements</a>
          <ErrorMessage component='small' name='forCredit' className='errors' />
        </div>
      </div>
    </section>

    {form.values.requireDfs &&
      <React.Fragment>
        <section>
          <div className='field'>
            <label htmlFor='dfsLicense'>Title Agent / DFS License Number</label>
            <span> (Don't have it handy? <a href='https://licenseesearch.fldfs.com/' target='_blank'>Use this link to search it</a>)</span>
            <Field name='dfsLicense' type='text' id='dfsLicense' />
            <ErrorMessage component='small' name='dfsLicense' className='errors' />
          </div>
        </section>
        <section>
          <div className='field'>
            <label htmlFor='address'>Street Address (for delivery of your certificate of completion)</label>
            <Field name='address' type='text' id='address' />
            <ErrorMessage component='small' name='address' className='errors' />
          </div>
        </section>
        <section>
          <div className='field'>
            <label htmlFor='city'>City</label>
            <Field name='city' type='text' id='city' />
            <ErrorMessage component='small' name='city' className='errors' />
          </div>
          <div className='field'>
            <label htmlFor='state'>State</label>
            <Field name='state' type='text' id='state' maxLength='2' />
            <ErrorMessage component='small' name='state' className='errors' />
          </div>
          <div className='field'>
            <label htmlFor='zip'>Zip Code</label>
            <Field name='zip' type='text' id='zip' maxLength='5' />
            <ErrorMessage component='small' name='zip' className='errors' />
          </div>
          <div className='field'>
            <label htmlFor='mobile'>Mobile Number</label>
            <Field
              name='mobile'
              type='tel'
              id='mobile'
              component={MaskedInput}
              mask={phoneNumberMask}
              placeholderChar={'\u2000'}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
              value={form.values.mobile}
            />
          </div>
        </section>
      </React.Fragment>
    }
  </React.Fragment>
)

export const RegistrationSection = ({ terminal, section, form, toggleDfsRequirementsModal }) => {
  if (section[terminal]) {
    const applicableCascades = section.cascadedFrom.filter(a => a[terminal])
    const displaySection = (applicableCascades.length == 0 || (
      form.values.options &&
      applicableCascades.some(trigger => camelCase(trigger.sectionName) in form.values.options &&
        form.values.options[camelCase(trigger.sectionName)] == trigger.code)
    ))

    switch (section.sectionType) {
      case 'option_group':
        return (
          displaySection && <RegistrationOptions section={section} form={form} />
        )

      case 'dfs_form':
        return (
          displaySection && <DfsForm section={section} form={form} toggleDfsRequirementsModal={toggleDfsRequirementsModal} />
        )

      case 'share_contact_info':
        return (
          displaySection && <ShareContactInfoForm section={section} form={form} />
        )

      default:
        return null
    }
  } else {
    return null
  }
}

export const phoneRegExp = /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}/
export const phoneNumberMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

export const enableOptionGroupValidation = () => {
  Yup.addMethod(Yup.mixed, 'optionGroup', function (section, terminal) {
    if (section[terminal]) {
      const applicableCascades = section.cascadedFrom.filter(a => a[terminal])
      const triggers = applicableCascades.map(a => camelCase(a.sectionName))

      if (triggers.length > 0) {
        return this.when([ ...triggers ], {
          is: (...values) => {
            return applicableCascades.some((trigger, index) => trigger.code == values[index])
          },
          then: Yup.string().required('This field is required')
        })
      } else {
        return Yup.string().required('This field is required')
      }
    }
  })
}

export const enableDfsValidation = () => {
  Yup.addMethod(Yup.mixed, 'dfs', function (section, terminal) {
    if (section[terminal]) {
      const applicableCascades = section.cascadedFrom.filter(a => a[terminal])
      const triggers = applicableCascades.map(a => `options.${camelCase(a.sectionName)}`)

      return {
        requireDfs: Yup.boolean(),
        dfsLicense: Yup.string()
          .when(['requireDfs', ...triggers], {
            is: (requireDfs, ...values) => {
              return requireDfs &&
                (triggers.length == 0 || applicableCascades.some((trigger, index) => trigger.code == values[index]))
            },
            then: Yup.string().required('This field is required')
          }),
        address: Yup.string()
          .when(['requireDfs', ...triggers], {
            is: (requireDfs, ...values) => {
              return requireDfs &&
                (triggers.length == 0 || applicableCascades.some((trigger, index) => trigger.code == values[index]))
            },
            then: Yup.string().required('This field is required')
          }),
        city: Yup.string()
          .when(['requireDfs', ...triggers], {
            is: (requireDfs, ...values) => {
              return requireDfs &&
                (triggers.length == 0 || applicableCascades.some((trigger, index) => trigger.code == values[index]))
            },
            then: Yup.string().required('This field is required')
          }),
        state: Yup.string()
          .when(['requireDfs', ...triggers], {
            is: (requireDfs, ...values) => {
              return requireDfs &&
                (triggers.length == 0 || applicableCascades.some((trigger, index) => trigger.code == values[index]))
            },
            then: Yup.string().required('This field is required')
          }),
        zip: Yup.string()
          .when(['requireDfs', ...triggers], {
            is: (requireDfs, ...values) => {
              return requireDfs &&
                (triggers.length == 0 || applicableCascades.some((trigger, index) => trigger.code == values[index]))
            },
            then: Yup.string().required('This field is required')
          })
      }
    }
  })
}

export const customerInfoValidation = {
  firstName: Yup.string()
    .required('This field is required'),
  lastName: Yup.string()
    .required('This field is required'),
  company: Yup.string()
    .required('This field is required'),
  accountManager: Yup.string()
    .required('This field is required'),
  email: Yup.string()
    .email('Invalid email')
    .required('This field is required'),
  phone: Yup.string()
    .required('This field is required')
    .matches(phoneRegExp, 'Phone number is not valid')
}

export const employeeInfoValidation = {
  firstName: Yup.string()
    .required('This field is required'),
  lastName: Yup.string()
    .required('This field is required'),
  email: Yup.string()
    .email('Invalid email')
    .required('This field is required')
}

export const sponsorshipLevelValidation = Yup.object().shape({
  sponsorshipLevel: Yup.string()
    .required('This field is required')
})

export const sponsorInfoValidation = {
  firstName: Yup.string()
    .required('This field is required'),
  lastName: Yup.string()
    .required('This field is required'),
  company: Yup.string()
    .required('This field is required'),
  email: Yup.string()
    .email('Invalid email')
    .required('This field is required'),
  phone: Yup.string()
    .required('This field is required')
    .matches(phoneRegExp, 'Phone number is not valid')
}

export const blankInitialValues = {
  firstName: '',
  lastName: '',
  company: '',
  accountManager: '',
  email: '',
  phone: '',
  requireDfs: false,
  shareContactInfo: true,
  acknowledgeDfs: false,
  dfsLicense: '',
  mobile: '',
  address: '',
  city: '',
  state: 'FL',
  zip: ''
}
